var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEssays(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.862,
    height: 131.84,
    viewBox: "0 0 128.862 131.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diploma",
    transform: "translate(-5.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609",
    transform: "translate(7.66 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M140.088,64.431a64.131,64.131,0,0,1-11,36.024c-11.579,17.139-30.927,25.425-53.168,25.425-35.584,0-62.071-25.745-62.071-61.329,0-6.526-1.65-12.947.155-18.883A64.442,64.442,0,0,1,140.088,64.431Z",
    transform: "translate(-13.156 0)",
    fill: "#26afba"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M122.993,133.969a5.235,5.235,0,0,1-7.773-4.587V56.63a12.325,12.325,0,0,0-4.557-9.583l-.084-.068a12.418,12.418,0,0,0-7.793-2.767H47.563a3.052,3.052,0,0,0-3.052,3.052v3.3H37.955V81.122c0,6.972-10.394,7.315-10.8.355q-.022-.38-.039-.761C26.632,70.065,11.606,68.187,8.505,78.39A64.588,64.588,0,0,0,31.38,148.65l10.274,6.326a64.767,64.767,0,0,0,49.191,3.215v0c.03-.01.911-.313,1.631-.579a64.54,64.54,0,0,0,16.189-8.8v0a64.788,64.788,0,0,0,5.528-4.629h0c.205-.192.664-.629,1.026-.982h0a64.786,64.786,0,0,0,7.849-9.274Z",
    transform: "translate(0 -32.721)",
    fill: "#0e7f8a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611",
    transform: "translate(31.401 15.908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M203.748,85.642v99.973h41.469q1.755-.867,3.448-1.836V85.642Z",
    transform: "translate(-177.956 -79.292)",
    fill: "#faf58c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M104.5,179.286a64.438,64.438,0,0,0,10.266,6.329h16.38V85.642H104.505Z",
    transform: "translate(-104.505 -79.292)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M196.921,61.21h53.247v91.723H196.921Z",
    transform: "translate(-172.903 -61.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M166.84,148.818v-1.34l-11.94.072a2.636,2.636,0,0,1-2.636-2.636v-2.375A2.636,2.636,0,0,1,154.9,139.9h38.692v-3.559H154.9a2.636,2.636,0,0,1-2.636-2.636v-2.375A2.636,2.636,0,0,1,154.9,128.7h38.692v-3.559H154.9a2.636,2.636,0,0,1-2.636-2.636v-2.375a2.636,2.636,0,0,1,2.636-2.636h38.692v-3.559H154.9a2.636,2.636,0,0,1-2.636-2.636v-2.375a2.636,2.636,0,0,1,2.636-2.636h38.692v-3.559H154.9a2.636,2.636,0,0,1-2.636-2.636V97.712a2.636,2.636,0,0,1,2.636-2.636h38.692V91.517H154.9a2.636,2.636,0,0,1-2.636-2.636V86.505a2.636,2.636,0,0,1,2.636-2.636h38.692V80.31H152.264V61.21H129.727v99.973h70.71V148.89Z",
    transform: "translate(-123.172 -61.21)",
    fill: "#faf58c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    transform: "translate(17.458 16.141)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M171.68,123.318h52.962v3.559H171.68Z",
    transform: "translate(-171.68 -123.318)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M171.68,166.437h52.962V170H171.68Z",
    transform: "translate(-171.68 -155.231)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M171.68,209.557h52.962v3.559H171.68Z",
    transform: "translate(-171.68 -187.144)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M171.68,252.676h52.962v3.559H171.68Z",
    transform: "translate(-171.68 -219.057)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M171.68,295.8h52.962v3.559H171.68Z",
    transform: "translate(-171.68 -250.971)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M171.68,338.915h52.962v3.559H171.68Z",
    transform: "translate(-171.68 -282.884)",
    fill: "#ffc305"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M171.68,382.035h26.209v3.559H171.68Z",
    transform: "translate(-171.68 -314.797)",
    fill: "#ffc305"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M294.954,446.109l-.844-2.161a.863.863,0,0,0-1.146-.478l-2.13.92a.863.863,0,0,1-1.138-1.124l7.471-17.9,6.856,2.861-7.471,17.9A.862.862,0,0,1,294.954,446.109Z",
    transform: "translate(-241.517 -330.725)",
    fill: "#e20a62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M334.534,446.109l.844-2.161a.863.863,0,0,1,1.146-.478l2.13.92a.862.862,0,0,0,1.138-1.124l-7.471-17.9-6.856,2.861,7.471,17.9a.862.862,0,0,0,1.6-.018Z",
    transform: "translate(-268.039 -330.725)",
    fill: "#ff5551"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 8.249,
    cy: 8.249,
    r: 8.249,
    transform: "translate(51.583 83.474)",
    fill: "#ff5551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M308.018,391.133a8.2,8.2,0,0,1,.991-3.92,1.188,1.188,0,0,0-1.578-1.624,8.247,8.247,0,0,0-4.442,7.079,8.255,8.255,0,0,0,9.079,8.449,1.394,1.394,0,0,0,.455-2.632A8.25,8.25,0,0,1,308.018,391.133Z",
    transform: "translate(-251.402 -301.186)",
    fill: "#e20a62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M302.8,373.969a8.249,8.249,0,1,1-8.249,8.249,8.249,8.249,0,0,1,8.249-8.249m0-2.961a11.21,11.21,0,1,0,11.21,11.21A11.223,11.223,0,0,0,302.8,371.008Z",
    transform: "translate(-242.971 -290.495)",
    fill: "#ff8500"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssays);
export default __webpack_public_path__ + "static/media/essays.ec85b37c3251d14343993405382d36bc.svg";
export { ForwardRef as ReactComponent };